/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Totals of the parent legal entity (last declared fiscal year) and its subsidiaries
 * @export
 * @interface SubsidiariesTotalsDto
 */
export interface SubsidiariesTotalsDto {
    /**
     * Cumulated revenue, in euros
     * @type {number}
     * @memberof SubsidiariesTotalsDto
     */
    totalRevenue: number;
    /**
     * Cumulated number of employees
     * @type {number}
     * @memberof SubsidiariesTotalsDto
     */
    totalEmployees: number;
    /**
     * Number of subsidiaries
     * @type {number}
     * @memberof SubsidiariesTotalsDto
     */
    subsidiariesCount: number;
    /**
     * False when the parent has no declared financial data (it then counts as 0)
     * @type {boolean}
     * @memberof SubsidiariesTotalsDto
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the SubsidiariesTotalsDto interface.
 */
export function instanceOfSubsidiariesTotalsDto(value: object): value is SubsidiariesTotalsDto {
    if (!('totalRevenue' in value) || value['totalRevenue'] === undefined) return false;
    if (!('totalEmployees' in value) || value['totalEmployees'] === undefined) return false;
    if (!('subsidiariesCount' in value) || value['subsidiariesCount'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    return true;
}

export function SubsidiariesTotalsDtoFromJSON(json: any): SubsidiariesTotalsDto {
    return SubsidiariesTotalsDtoFromJSONTyped(json, false);
}

export function SubsidiariesTotalsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubsidiariesTotalsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRevenue': json['totalRevenue'],
        'totalEmployees': json['totalEmployees'],
        'subsidiariesCount': json['subsidiariesCount'],
        'isComplete': json['isComplete'],
    };
}

export function SubsidiariesTotalsDtoToJSON(json: any): SubsidiariesTotalsDto {
    return SubsidiariesTotalsDtoToJSONTyped(json, false);
}

export function SubsidiariesTotalsDtoToJSONTyped(value?: SubsidiariesTotalsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRevenue': value['totalRevenue'],
        'totalEmployees': value['totalEmployees'],
        'subsidiariesCount': value['subsidiariesCount'],
        'isComplete': value['isComplete'],
    };
}

